import React from 'react';
import PropTypes from 'prop-types';

import PublicLayout from './Public';

const Layout = ({ children, ...props }) => {
  return <PublicLayout {...props}>{children}</PublicLayout>;
};

Layout.displayName = 'Layout';

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
